import {SET_PAGE} from "app/actions/page";

export default function page({action, state}) {
  switch(action.type) {
    case SET_PAGE:
      return action.page ? {...action.page} : null;
    default:
      return state;
  }
}
